import screenfull from 'screenfull'
import { signal } from 'services/SignalsService'
import { debug } from 'settings/custom/build'
import { Device } from 'utils/Device'

export default class FullscreenEntity extends PIXI.Container {
  constructor() {
    super()

    this.visible = false

    if (Device.isIOS()) {
      this.visible = false
    }
    else if (Device.isMobile()) {
      if(debug) {
        return
      }
      if (screenfull.isEnabled) {
        this.visible = !screenfull.isFullscreen
        screenfull.on('change', () => {
          this.visible = !screenfull.isFullscreen
        })

        screenfull.on('error', () => {
          this.visible = false
        })

        signal.on('BUTTON:fullscreen', () => {
          screenfull.request(document.body)
        })
      }
      else if (Device.isSafari()) {
        this.visible = false
      }
      else {
        this.visible = false
      }
    }
  }
}
